type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface HttpOptions extends RequestInit {
  headers?: Record<string, string>;
  body?: string | FormData | Blob;
}

const httpClient = async (
  method: HttpMethod,
  apiUrl: string,
  options: HttpOptions = {},
) => {
  try {
    const response = await fetch(apiUrl, {
      method,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error: unknown) {
    console.error('Fetch error:', error);
  }
};

export default httpClient;
